// Every season, each hosted on its own domain/subdomain. Update
// `currentSeasonId` per branch/deployment (the current season's site is
// this deployment itself, so it's shown highlighted rather than as a link).
export const seasons = [
  { id: "2023-24", label: "2023-24 sezonu", url: "https://2023-24.ensuperlig.com/" },
  { id: "2024-25", label: "2024-25 sezonu", url: "https://2024-25.ensuperlig.com/" },
  { id: "2025-26", label: "2025-26 sezonu", url: "https://2025-26.ensuperlig.com/" },
  { id: "2026-27", label: "2026-27 sezonu", url: "https://ensuperlig.com/" },
];

export const currentSeasonId = "2026-27";

// Plain "2026-27" for SEO copy (page titles/descriptions), where the
// " sezonu" suffix used in the season-switcher label above doesn't fit
// the surrounding Turkish sentence structure (e.g. "... 2026-27 Sezonu
// Puan Durumu").
export const currentSeasonLabel = currentSeasonId;
